import { PageLoading } from 'embroil/components/loading';

<template>
  <PageLoading @message="Loading games..." @subtitle="Discovering games and their details for you" />
</template>
